var App = App || {};

App.PageEvent = (function ($) {
    "use strict";

    function formatDate(date) {
        return date.toLocaleDateString(undefined, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    function formatTime(date) {
        return date.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit'
        });
    }

    function isSameDay(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }

    function applyLocalTimes() {
        try {
            var groups = document.querySelectorAll('.page-event-content-timing > div');

            groups.forEach(function (group) {

                var timeElements = group.querySelectorAll('.js-local-time');

                if (timeElements.length !== 2) {
                    return;
                }

                var start = new Date(timeElements[0].getAttribute('datetime'));
                var end = new Date(timeElements[1].getAttribute('datetime'));

                if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                    return;
                }

                if (isSameDay(start, end)) {
                    timeElements[0].textContent =
                        formatTime(start);

                    timeElements[1].textContent =
                        formatTime(end);

                } else {
                    timeElements[0].textContent =
                        formatDate(start) + " " + formatTime(start);

                    timeElements[1].textContent =
                        formatDate(end) + " " + formatTime(end);
                }
            });
        }
        catch (e) {
            console.error("PageEvent error:", e);
        }
    }

    function init() {
        applyLocalTimes();
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.PageEvent.init();
});